module.exports = __webpack_public_path__ + "static/media/18.14bd9347.mp3";